<template>
<div>
  <input type="checkbox"
        :name="name" :id="id" :checked="value"
        @input="updateChecked($event.target.checked)">
    <label :for="id" :id="id + '-label'">
      <svg viewBox="0 0 96 96">
        <rect class="box" :class="{reverse: reverse}"
          x="3" y="3" width="90" height="90" rx="22.02"/>
        <polyline class="check" points="19.57 53.61 36.95 70.99 77.94 30"/>
      </svg>
    <span><slot></slot></span>
  </label>
</div>
</template>

<script>
export default {
  name: 'Checkbox',
  data() {
    return {
      reverse: false
    };
  },
  props: ['id', 'name', 'value'],
  methods: {
    updateChecked(checked) {
      this.animateOnUncheck(checked);
      this.$emit('input', checked);
    },
    animateOnUncheck(checked) {
      if (!checked) {
        this.reverse = true;
        setTimeout(() => {
          this.reverse = false;
        }, 525);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
input[type=checkbox] {
  display: none;
  pointer-events: none;

  & + label {
    cursor: pointer;
    transition: color .25s;
    font-size: 15px;
    display: grid;
    align-items: center;
    margin: 10px 15px;
    line-height: 18px;
    grid-template-columns: 22px 1fr;

    a {
      color: #707070;
      transition: color 0.25s;

      &:hover {
        color: #ccc;
      }
    }

    svg {
      width: 22px;
      stroke: rgb(0,124,226);
      stroke-width: 8;
      stroke-linecap: round;
      stroke: #fff;

      .box {
        fill: #707070;
        stroke-dasharray: 325;
        stroke-dashoffset: 325;
      }

      .check {
        stroke-dasharray: 85;
        stroke-dashoffset: 85;
        fill: none;
        transition: stroke-dashoffset .3s ease-out;
      }
    }

  span {
    padding-top: .1em;
    margin-left: .6em;
  }
  }

  &:checked + label {
    color: #ddd;

    & a {
      color: #ddd;

      &:hover {
        color: #fff;
      }
    }

    .box {
      animation: check 0.5s ease-out;
      fill: #3477e4;
    }
    .check {
      stroke-dashoffset: 0;
    }
  }

  & + label {
    .box.reverse {
      animation: uncheck 0.5s ease-out;
    }
  }

  @keyframes check {
    0% {
      stroke-dashoffset: 325;
    }
    50% {
      stroke-dashoffset: 650;
    }

    100% {
      stroke-dashoffset: 975;
    }
  }

  @keyframes uncheck {
    0% {
      stroke-dashoffset: 975;
    }
    50% {
      stroke-dashoffset: 650;
    }

    100% {
      stroke-dashoffset: 325;
    }
  }
}
</style>
